import { observer } from 'mobx-react-lite'
import { OCRScopeNewJobButton } from '@/features/jobs/scoping/components/OCRScopeNewJobButton'
import { type CreateOCRScopeJobsViewModel } from '@/features/jobs/scoping/components/CreateOCRScopeJobsDialog/CreateOCRScopeJobsViewModel'

export interface OCRScopeNewJobButtonContainerProps {
  vm: CreateOCRScopeJobsViewModel
  wideSlimButton?: boolean
}

export const OCRScopeNewJobButtonContainer = observer(
  function OCRScopeNewJobButtonContainer({
    vm,
    wideSlimButton,
  }: OCRScopeNewJobButtonContainerProps) {
    return (
      <OCRScopeNewJobButton
        wideSlimButton={wideSlimButton}
        onAddFiles={vm.addFiles}
        onOpen={vm.open}
      />
    )
  },
)
